import { render } from "./StaffAssessmentTestPage.vue?vue&type=template&id=1b2bb1ec&scoped=true"
import script from "./StaffAssessmentTestPage.vue?vue&type=script&lang=js"
export * from "./StaffAssessmentTestPage.vue?vue&type=script&lang=js"

import "./StaffAssessmentTestPage.vue?vue&type=style&index=0&id=1b2bb1ec&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2bb1ec"]])

export default __exports__